module.exports = __webpack_public_path__ + "img/8.88412698.jpg";